module.exports = __webpack_public_path__ + "static/img/agricultural_bank1.db8dd308.png";